import React from 'react';

const WhatsAppButton: React.FC = () => {
  const phoneNumber = "5547992104226"; 
  const message = encodeURIComponent("Olá! Gostaria de mais informações sobre a Intrex.");

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9999,
        transition: 'transform 0.3s ease',
        cursor: 'pointer',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
      onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
    >
      <img 
        src="/images/whatsapp.png" 
        alt="WhatsApp" 
        style={{ 
          width: '60px', 
          height: '60px', 
          display: 'block',
          filter: 'drop-shadow(0 4px 10px rgba(0,0,0,0.3))' 
        }} 
      />
    </a>
  );
};

export default WhatsAppButton;